import { absolutePath } from "../../absolutePath";

export const accessGroupContent = {
  update: (accessGroupId: number) =>
    absolutePath(`admin/access_groups/${accessGroupId}/contents`),
};
